import React, { useState, useRef, useEffect } from "react";
import { FaExclamationCircle } from "react-icons/fa";
import styles from "./AdharRegistrartion.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserByNumber,
  verifyGetByNumber,
  verifyGetByNumberUser,
  getUserDetails,
} from "../../../../store/slices/abhaRegistrationSlice";
import { Button } from "react-bootstrap";
import {
  MAX_OTP_RESEND_ATTEMPTS,
  getOtpResendAttemptMessage,
} from "./otpResendAttempts";

export const MobileVerification = ({
  setModalVisible,
  setShowRegistrationModal,
  setAadharNumber,
  loading,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [showOtpStep, setShowOtpStep] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId =clinicInfo?.[0]?.clinicId ||null;
  const [errorMessage, setErrorMessage] = useState("");
  const [otpError, setOtpError] = useState("");
  const [showmobilefield, setShowmobilefield] = useState(true);
  const [showPatientListModal, setShowPatientListModal] = useState(false);
  const [linkedPatients, setLinkedPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [maxAttemptsReached, setMaxAttemptsReached] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [timer, setTimer] = useState(20);
  const OTP_RESEND_TIMEOUT = 60;

  useEffect(() => {
    let interval;
    if (showOtpStep && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtpStep, timer]);

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setMobileNumber(value);
      setErrorMessage("");
    }
  };

  const handleNextClick = async () => {
    setAadharNumber("");
    if (mobileNumber.length !== 10) {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
      return;
    }
    setErrorMessage("");
    try {
      const response = await dispatch(
        getUserByNumber({
          phone: mobileNumber,
          clinicId,
          token
        })
      );
      const txnId = response?.payload?.result?.list?.txnId;
      if (txnId) {
        setShowmobilefield(false);
        setShowOtpStep(true);
        setTimer(OTP_RESEND_TIMEOUT);
        setErrorMessage("");
      } else {
        setErrorMessage(
          "Mobile number verification failed. Please ensure you've entered a registered mobile number."
        );
      }
    } catch (error) {
      console.error("Error in handleNextClick:", error);
      setErrorMessage("Something went wrong. Please try again later.");
    }
  };

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleResendOtp = async () => {
    if (timer > 0 || resendCount >= MAX_OTP_RESEND_ATTEMPTS) return;
    try {
      const response = await dispatch(
        getUserByNumber({
          phone: mobileNumber,
          clinicId,
          token
        })
      );
      if (response?.payload?.result?.list?.txnId) {
        setTimer(OTP_RESEND_TIMEOUT);
        setOtp(["", "", "", "", "", ""]);
        setOtpError("");
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        const nextCount = resendCount + 1;
        setResendCount(nextCount);
        if (nextCount >= MAX_OTP_RESEND_ATTEMPTS) {
          setMaxAttemptsReached(true);
        }
        return;
      } else {
        console.error("Failed to resend OTP");
        setOtpError("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      setOtpError("An error occurred. Please try again.");
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    setOtpError("");

    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      setOtpError("");

      if (otp[index] === "") {
        if (index > 0 && inputRefs.current[index - 1]) {
          inputRefs.current[index - 1].focus();
        }
      }
    }
  };

  const handleFinalClick = async () => {
    if (!otp.every((digit) => digit !== "")) {
      setOtpError("Please enter a valid OTP.");
      return;
    }

    const otpString = otp.join("");
    setOtpError("");

    try {
      const response = await dispatch(
        verifyGetByNumber({
          clinicId,
          otp: otpString,
          token
        })
      );
      if (response?.payload?.result?.list?.authResult === "success") {
        setOtpError("");
        setShowOtpStep(false);
        setShowPatientListModal(true);
        setLinkedPatients(response?.payload?.result?.list?.accounts);
      } else {
        setOtpError("Invalid OTP. ");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An error occurred while verifying OTP. Please try again.");
    }
  };

  const handlePatientSelection = (patient) => {
    setSelectedPatient(patient);
  };

  const handleNextPatient = async () => {
    if (selectedPatient) {
      const verifyResponse = await dispatch(
        verifyGetByNumberUser({
          clinicId,
          abhaNumber: selectedPatient?.ABHANumber,
          token
        })
      );
      if (verifyResponse?.payload?.success) {
        const userDetailsResponse = await dispatch(
          getUserDetails({ clinicId, token })
        );

        if (userDetailsResponse?.payload?.success) {
          setOtpError("");
          setShowRegistrationModal(false);
          setModalVisible(true);
        } else {
          setOtpError("Something went wrong. Please try again");
        }
      } else {
        setOtpError("Something went wrong. Please try again");
      }
    }
  };

  return (
    <>
      {showmobilefield && (
        <div>
          <div className="form-group">
            <label className="fw-bold">Mobile Number:</label>
            <input
              type="text"
              className="form-control"
              value={mobileNumber}
              onChange={handleMobileChange}
              maxLength={10}
            />
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
            <p className={styles.consentText}>
              <FaExclamationCircle /> Please ensure that the mobile number is
              linked with Aadhaar for OTP Authentication.
            </p>
          </div>
          <div className="text-end w-100">
            <button
              className="btn btn-primary"
              onClick={handleNextClick}
              disabled={loading}
            >
              {loading ? "Processing..." : "Next"}
            </button>
          </div>
        </div>
      )}
      {showOtpStep && (
        <div>
          <p>Enter OTP sent to {mobileNumber}</p>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                className="form-control text-center"
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleOtpKeyDown(e, index)}
                maxLength={1}
                ref={(el) => (inputRefs.current[index] = el)}
                style={{ width: "3rem" }}
              />
            ))}
          </div>
          {otpError && <p className="text-danger small mt-2">{otpError}</p>}
          {resendCount > 0 && (
            <p
              className={`small mt-2 mb-0 ${
                resendCount >= MAX_OTP_RESEND_ATTEMPTS
                  ? "text-danger"
                  : "text-success"
              }`}
            >
              {getOtpResendAttemptMessage(resendCount)}
            </p>
          )}

          <div className="mt-2">
            {!maxAttemptsReached ? (
              <>
                <small className="fs-13">Didn't receive the OTP?</small>{" "}
                <small
                  onClick={handleResendOtp}
                  style={{
                    cursor: timer > 0 ? "not-allowed" : "pointer",
                    color: timer > 0 ? "gray" : "blue",
                    marginLeft: "0.5rem",
                  }}
                >
                  Resend OTP
                </small>
                <span className="ms-3">Time left: {formatTimer(timer)}</span>
              </>
            ) : (
              <div className="text-black fs-13">
                Resend OTP limit reached. Please try again later.
              </div>
            )}
          </div>

          <div className="text-end mt-3">
            <button
              className="btn btn-success"
              onClick={handleFinalClick}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </button>
          </div>
        </div>
      )}
      {showPatientListModal && (
        <div>
          <h5 className="fw-bold mb-4">
            Linked Patients{" "}
            <span className={styles.noteText}>
              (Just choose one patient for registration process)
            </span>
          </h5>
          <div className="container-fluid px-0">
            <div className="row">
              {linkedPatients?.map((patient, index) => (
                <div
                  key={index}
                  className="col-12 col-md-4 mb-4 d-flex justify-content-start"
                >
                  <div
                    className={`${styles.cardContainer} position-relative shadow-sm w-100`}
                  >
                    <div className={`${styles.cardContent} position-relative`}>
                      <input
                        type="radio"
                        name="patientSelection"
                        onChange={() => handlePatientSelection(patient)}
                        className={styles.radioInput}
                      />
                      <img
                        src={`data:image/jpeg;base64,${patient?.profilePhoto}`}
                        alt="Profile"
                        className={styles.profileimg}
                      />
                    </div>

                    <div className={styles.cardBottom}>
                      <div className={styles.patientName} title={patient?.name}>
                        {patient?.name}
                      </div>
                      <div className={styles.patientABHANumber}>
                        {patient?.ABHANumber}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="text-end mt-3">
            <Button
              className="btn btn-primary"
              onClick={handleNextPatient}
              disabled={!selectedPatient}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileVerification;
